// extracted by mini-css-extract-plugin
module.exports = {"error_message":"shared__error_message___3z8Bv"};